import React, { useState, useEffect } from 'react'
import * as txApi from '../clients/tx-sls-client'
import {config} from '../config'

const txdomain = config()['tourneyx-url']

const TournamentDropdown  = ({ otherTournamentsList , tournamentInfo  }) => {

    const [setTournament, setTournamentsList] = useState([]);

    var tournament_list = [];

    console.log('otherTournamentsList passed ===>>', otherTournamentsList);

    const onTournamentSelect = ( e ) => {
        //console.log('Selected tournament slug is :::', e.target.value);

        var tournament_slug = e.target.value;

        if( tournament_slug != '0'){
            console.log('Selected tournament slug is :::', tournament_slug);

            if(tournamentInfo && tournamentInfo.redirect_to_old_tourney_leaderboard === '1'){
                window.location.href=`${txdomain}/app/tourney-leaderboard/${tournament_slug}`;
            }else{
                window.location.href=`${txdomain}/leaderboard/standings/${tournament_slug}`;
            }
        }
    }

    return (
        <>
            <div className="custom-select-dropdown">
                <select className="form-control custom-select-class" onChange={onTournamentSelect}>
                    <option className="custom-option-class" value="0">--Find Events--</option>               
                    {
                        
                        tournament_list = otherTournamentsList.map((tournament,index) =>(
                            
                            <option key={index} className="custom-option-class" value={tournament.slug}>{tournament.tournament_title}</option>
                        ))
                    }
                </select>
            </div>

            
        </>
    )

}

export default TournamentDropdown